import { Box, Container, Flex, Text, Divider, SimpleGrid, Input, FormControl, FormLabel, Select, ButtonGroup, Button, FormErrorMessage, Textarea, FormHelperText } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import LoadingScreen from "components/loading-screen";
import Layout from "scenes/layouts";
import { useNavigate, useParams } from "react-router-dom";
import { Field, Formik } from "formik";
import LogosNotification from "utils/notification-utils";
import VoucherService from "../../services/vouchers/voucher-service";
import { SingleDatepicker } from "chakra-dayzed-datepicker";
import ProgramService from "../../services/programs/program-service";
import BannerService from "../../services/banners/banner-service";
import AuthorService from "../../services/authors/author-service";
import ReactQuill from "react-quill";

const formInitialValue = {
    name: '',
    shortBioData: '',
    about: '',
    posterImage: null
};
const modules = {
    toolbar: [
        [{ 'header': [1, 2, 3, 4, 5, false] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'align': [] }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
        ['link', 'image', 'video'],
        ['clean']
    ],
    clipboard: {
        // toggle to add extra line breaks when pasting HTML:
        matchVisual: false
    },
    imageResize: {
        parchment: ReactQuill.Quill.import('parchment'),
        modules: ['Resize', 'DisplaySize']
    },
    //blotFormatter: { }
};

const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'video', 'align', 'color', 'background'
];

const NewAuthorScene = (): ReactElement => {
    const navigate = useNavigate();
    const [isSaving, setSaving] = useState<boolean>(false);
    const [formValue, setFormValue] = useState<any>(formInitialValue);
    const [about, setAbout] = useState<string>('');

    const handleFormSubmit = (values: any) => {
        setSaving(true);
        AuthorService.Create(
            values.name,
            values.shortBioData,
            about,
            values.posterImage
        ).then((res: any) => {
            LogosNotification.Success("Author berhasil dibuat.");
            navigate(`/authors/${res.result.id}`);
        }).finally(() => {
            setSaving(false);
        });
    };

    return (
        <Layout>
            <Container maxWidth={"8xl"} pt={10}>
                <Box>
                    <Flex>
                        <Text fontSize={{ base: '2xl', md: '3xl' }} fontWeight={"bold"}>Buat Author Baru</Text>
                    </Flex>
                    <Formik initialValues={formValue} onSubmit={handleFormSubmit}>
                        {
                            ({ handleSubmit, errors, touched, values, setFieldValue }) => (
                                <form onSubmit={handleSubmit} noValidate={true}>
                                    <Box rounded={'lg'} fontSize={'sm'} border={'1px solid'} borderColor={'blackAlpha.400'}>

                                        <Box px={8} pt={4}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.name && touched.name)}>
                                                    <FormLabel htmlFor='name'>Nama Author</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='name'
                                                        placeholder='Nama Author'
                                                        name={'name'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Nama Author wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.name}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Box px={8} pt={4}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.shortBioData && touched.shortBioData)}>
                                                    <FormLabel htmlFor='shortBioData'>Profesi</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='shortBioData'
                                                        placeholder='Profesi'
                                                        name={'shortBioData'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Profesi wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.shortBioData}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Box px={8} py={4}>
                                            <FormControl>
                                                <FormLabel htmlFor='price'>Tentang Author</FormLabel>
                                                <ReactQuill
                                                    theme="snow"
                                                    value={about}
                                                    onChange={setAbout}
                                                    placeholder="Tentang Author"
                                                    modules={modules}
                                                    formats={formats}
                                                />
                                            </FormControl>
                                        </Box>

                                        <Box px={8} py={2}>
                                            <SimpleGrid columns={{ base: 1 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.posterImage && touched.posterImage)}>
                                                    <FormLabel htmlFor='screenshot'>Gambar Author</FormLabel>
                                                    <input
                                                        type={'file'}
                                                        id='posterImage'
                                                        name={'posterImage'}
                                                        accept="image/*"
                                                        onChange={(event: any) => {
                                                            setFieldValue("posterImage", event.currentTarget.files[0]);
                                                        }}
                                                    />
                                                    <FormHelperText>Ukuran: 875 x 875 px</FormHelperText>
                                                    <FormErrorMessage>{errors.posterImage}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Divider mt={4} />

                                        <Box px={8} py={8}>
                                            <ButtonGroup gap={2}>
                                                <Button type={'submit'} isLoading={isSaving}>Simpan</Button>
                                                <Button variant={'outline'} onClick={() => { navigate('/authors') }}>Kembali</Button>
                                            </ButtonGroup>
                                        </Box>
                                    </Box>
                                </form>
                            )
                        }
                    </Formik>
                </Box>
            </Container>
        </Layout >
    );
};

export default NewAuthorScene;